<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>我的积分
    </v-card-title>
    <v-card-text>
      <v-row align="center" class="mt-2 mb-6">
        <v-col cols="auto">
          <date-editor v-model="queryParam.tm1" outlined dense hide-details label="开始时间"></date-editor>
        </v-col>
        <v-col cols="auto">
          <date-editor v-model="queryParam.tm2" outlined dense hide-details label="截止日期"></date-editor>
        </v-col>
        <v-col cols="auto">
          <v-text-field v-model="queryParam.searchValue" hide-details dense single-line outlined label="关键词"></v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-btn color="primary" @click="onSearch">查询</v-btn>
        </v-col>
      </v-row>
      <v-data-table :headers="headers" :items="dataList" hide-default-footer disable-sort>
        <template v-slot:item.sn="{ item }">{{dataList.indexOf(item)+1}}</template>
        <template v-slot:item.ct="{ value }">{{Utility.fmtDt(value)}}</template>
      </v-data-table>
      <v-pagination v-if="pagination.num>0" v-model="pagination.index" :length="pagination.num" :total-visible="pagination.size" @input="onPage" />
    </v-card-text>
  </v-card>
</template>
<script>
import { queryPoint } from '@/plugins/api';
export default {
  data () {
    return {
      headers: [
        { text: '#', value: 'sn' },
        { text: '积分', value: 'amount' },
        { text: '变动时间', value: 'ct' },
        { text: '变动后余额', value: 'balance', },
        { text: '备注', value: 'remark' },
      ],
      dataList: [],
      pagination: { index: 1, size: 10, num: 0, total: 0 },
      queryParam: { searchValue: '', tm1: '', tm2: '' },
    }
  },
  methods: {
    dataQuery (param) {
      if (param.tm1) param.tm1 = Number(this.Utility.replaceAll(param.tm1, '-'));
      if (param.tm2) param.tm2 = Number(this.Utility.replaceAll(param.tm2, '-'));
      queryPoint(param).then(res => {
        this.dataList = res.data;
        this.pagination = res.pagination;
      })
    },
    onPage () {
      let param = { ...this.queryParam, pagination: { index: this.pagination.index, size: this.pagination.size } }
      this.dataQuery(param);
    },
    onSearch () {
      let param = { ...this.queryParam, pagination: { index: 1, size: this.pagination.size } }
      this.dataQuery(param);
    }
  },
  created () {
    this.onSearch()
  }
}
</script>